import Vue from 'vue';
import { assign, has } from 'lodash';
import * as api from 'api/api-stuff-to-eat';
import { updateArrayItemByID, removeArrayItemByID } from 'utils/array';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  empty: false,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
  timestamp: null,
  meta: {},
  data: [],
};

const neutralState = {
  fetching: false,
  fetched: true,
  empty: false,
  saving: false,
  saveError: null,
  error: null,
  notFound: null,
  timestamp: null,
};

const state = {};

const getters = {
  StuffToEatContents: state => id => state[id],
};

const actions = {
  GetStuffToEatContents({ commit }, params) {
    const id = params.id;
    const type = params.type;
    commit(types.FETCH_STUFF_TO_EAT_CONTENTS_START, { id });
    api.getContents(
      type,
      id,
      (response) => {
        commit(types.RECEIVE_STUFF_TO_EAT_CONTENTS, { id, response });
      },
      (description, status, error) => {
        commit(types.FETCH_STUFF_TO_EAT_CONTENTS_ERROR, { id, error });
      },
    );
  },
  UpdateStuffToEatContentSequence({ commit }, params) {
    console.log('UpdateStuffToEatContentSequence', params);
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const payload = params.payload;
      api.updateContentSequence(
        type,
        id,
        payload,
        (response) => {
          commit(types.UPDATE_STUFF_TO_EAT_CONTENT_SEQUENCE_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          commit(types.UPDATE_STUFF_TO_EAT_CONTENT_SEQUENCE_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  ClearStuffToEatContents({ commit }, { id }) {
    commit(types.CLEAR_STUFF_TO_EAT_CONTENTS, { id });
  },
  AddStuffToEatContentToContentsList({ commit }, { id, response }) {
    commit(types.ADD_STUFF_TO_EAT_CONTENT_TO_CONTENTS_LIST, { id, response });
  },
  UpdateStuffToEatContentInContentsList({ commit }, { id, response }) {
    commit(types.UPDATE_STUFF_TO_EAT_CONTENT_IN_CONTENTS_LIST, { id, response });
  },
  RemoveStuffToEatContentFromContentsList({ commit }, { id, entityContentID }) {
    commit(types.REMOVE_STUFF_TO_EAT_CONTENT_FROM_CONTENTS_LIST, { id, entityContentID });
  },
};

const mutations = {
  [types.FETCH_STUFF_TO_EAT_CONTENTS_START](state, { id }) {
    console.log('FETCH_STUFF_TO_EAT_CONTENTS_START');
    if (has(state, id)) Vue.set(state, id, assign({}, initState, { fetching: true }));
    else Vue.set(state, id, assign({}, neutralState, { fetching: true }));
  },
  [types.FETCH_STUFF_TO_EAT_CONTENTS_ERROR](state, { id, error }) {
    console.log('FETCH_STUFF_TO_EAT_CONTENTS_ERROR');
    Vue.set(state, id, assign(state[id], neutralState, { error }));
  },
  [types.RECEIVE_STUFF_TO_EAT_CONTENTS](state, { id, response }) {
    console.log('RECEIVE_STUFF_TO_EAT_CONTENTS', response);
    Vue.set(state, id, assign(state[id], neutralState, { ready: true, timestamp: new Date().valueOf(), meta: response.meta, data: response.data }));
  },

  [types.CLEAR_STUFF_TO_EAT_CONTENTS](state, { id }) {
    console.log('CLEAR_STUFF_TO_EAT_CONTENTS');
    Vue.set(state, id, assign({}, initState));
  },

  [types.UPDATE_STUFF_TO_EAT_CONTENT_SEQUENCE_ERROR](state, { id, saveError }) {
    console.log('UPDATE_STUFF_TO_EAT_CONTENT_SEQUENCE_ERROR');
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.UPDATE_STUFF_TO_EAT_CONTENT_SEQUENCE_SUCCESSFUL](state, { id, response }) {
    console.log('UPDATE_STUFF_TO_EAT_CONTENT_SEQUENCE_SUCCESSFUL', response.data);
    // each(response.data, (item, index) => {
    //   Vue.set(state[id].data, index, item);
    // });
    Vue.set(state, id, assign(state[id], neutralState, { data: response.data, timestamp: new Date().valueOf() }));
  },

  [types.ADD_STUFF_TO_EAT_CONTENT_TO_CONTENTS_LIST](state, { id, response }) {
    console.log('ADD_STUFF_TO_EAT_CONTENT_TO_CONTENTS_LIST');
    state[id].data.push(response.data);
    Vue.set(state, id, assign(state[id], neutralState, { timestamp: new Date().valueOf() }));
  },

  [types.UPDATE_STUFF_TO_EAT_CONTENT_IN_CONTENTS_LIST](state, { id, response }) {
    console.log('UPDATE_STUFF_TO_EAT_CONTENT_IN_CONTENTS_LIST', response);
    updateArrayItemByID(state[id].data, response.data);
    Vue.set(state, id, assign(state[id], neutralState, { timestamp: new Date().valueOf() }));
  },

  [types.REMOVE_STUFF_TO_EAT_CONTENT_FROM_CONTENTS_LIST](state, { id, entityContentID }) {
    console.log('REMOVE_STUFF_TO_EAT_CONTENT_FROM_CONTENTS_LIST');
    removeArrayItemByID(state[id].data, entityContentID);
    Vue.set(state, id, assign(state[id], neutralState, { timestamp: new Date().valueOf() }));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-eat/entities/stuff-to-eat-contents.js